<template>
  <div id="app">
    <top-navigator></top-navigator>
    <main-body></main-body>
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import TopNavigator from './components/common/TopNavigator'
import MainBody from './components/common/MainBody'
import BottomFooter from './components/common/BottomFooter'

export default {
  name: 'App',
  components: {
    BottomFooter,
    MainBody,
    TopNavigator
  }
}
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue